import { render, staticRenderFns } from "./ModalConsignmentPrint.vue?vue&type=template&id=459a84a2&"
import script from "./ModalConsignmentPrint.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports